import {useScrollToSection} from '@aboutyou/ui-components';

export const SCROLL_TO_SIMILAR_ITEMS_PARAM = 'scrollToSimilarItems';

export const useSimilarItemsScrollManager = () => {
  const {disableScrollToSection, scrollToSection, shouldScrollToSection} =
    useScrollToSection(SCROLL_TO_SIMILAR_ITEMS_PARAM);

  return {
    scrollToSimilarItems: scrollToSection,
    disableScrollToSimilarItems: disableScrollToSection,
    shouldScrollSimilarItemsIntoView: shouldScrollToSection,
  };
};
